module.exports = "/_next/static/images/orb-1905bc2a9a47efee039a069ae224bcbe.svg";